import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import ProductPage from "@/pages/ProductPage";
import PolicyPage from "@/pages/PolicyPage";

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/product" element={<ProductPage />} />
          <Route path="/policies/:slug" element={<PolicyPage />} />
          <Route path="/pages/privacy-policy" element={<Navigate to="/policies/privacy-policy" replace />} />
          <Route path="/pages/terms-of-service" element={<Navigate to="/policies/terms-of-service" replace />} />
          <Route path="/pages/shipping-policy" element={<Navigate to="/policies/shipping-policy" replace />} />
          <Route path="/pages/refund-policy" element={<Navigate to="/policies/refund-policy" replace />} />
          {/* Legacy product/collection URLs → product page */}
          <Route path="/products/*" element={<Navigate to="/product" replace />} />
          <Route path="/collections/*" element={<Navigate to="/product" replace />} />
          <Route path="/checkout/*" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors theme="dark" />
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;
